import React, { ReactNode, useCallback } from "react";
import {
    Button,
    createTheme,
    createStyles,
    makeStyles,
    ThemeProvider,
    withStyles
} from "@material-ui/core";
import { ButtonColor, ButtonSize, ButtonVariant } from "../../models/element";

interface ButtonStyleProps {
    // サイズ
    size?: ButtonSize;
    // 配色
    color?: ButtonColor;
    // 表示形式
    variant?: ButtonVariant;
    // 文字サイズ
    fontSize?: string;
    // 活性化
    isActive?: boolean;
    // ボタンタイプ
    type?: string;
}

interface ButtonProps extends ButtonStyleProps {
    // 要素ID
    id?: string;
    // 内容
    children: ReactNode;
    // クリックイベント
    onClick: () => void;
}

const useStyles = makeStyles(() =>
    createStyles({
        customize: {
            width: "100%"
        }
    })
);

const CustomizeButton = withStyles(() => ({
    root: {
        color: "var(--white)",
        backgroundColor: "var(--main)",
        height: "40px",
        "&:hover": {
            color: "var(--white)",
            backgroundColor: "var(--main)"
        }
    }
}))(Button);

const theme = createTheme({
    palette: {
        action: {
            disabledBackground: "rgba(0, 0, 0, 0.12)"
        }
    }
});

function PuiButton({ id, children, onClick, type = "button", ...props }: ButtonProps) {
    const {
        size = "small",
        color = "secondary",
        variant = "contained",
        fontSize = "0.875rem",
        isActive = true
    } = props;
    const classes = useStyles();

    const handleClick = useCallback(() => {
        if (onClick) {
            onClick();
        }
    }, [onClick]);

    return (
        <ThemeProvider theme={theme}>
            <CustomizeButton
                id={id}
                size={size}
                color={color}
                variant={variant}
                disabled={!isActive}
                style={{ fontSize: fontSize }}
                onClick={handleClick}
                className={classes.customize}
                type={type as any}
            >
                {children}
            </CustomizeButton>
        </ThemeProvider>
    );
}

export default PuiButton;
